import { IForm } from '@/components/types'

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'name',
      type: 'input',
      label: '项目名称',
      placeholder: '请输入项目名称'
    }
  ]
}
